// header
document.addEventListener('DOMContentLoaded', function() {
  var $root = document.querySelector('html');
  var $header = document.getElementById('js-header');
  var _scrollPos = 0;
  // var _scrollPos = 0;
  var _offset = 0;
  var _headerOffset = 0;
  var _ticking = false;

  window.addEventListener('load', function() {
    if ($header) {
      _headerOffset = $header.getBoundingClientRect().top;
      // _headerOffset = $header.offsetHeight;
    }
    window.addEventListener('scroll', function(e) {
      if (!_ticking) {
        requestAnimationFrame(function() {
          _ticking = false;
          _scrollPos = window.pageYOffset;
          siteScrolled(_scrollPos);
        });
        _ticking = true;
      }
    }, false);
  }, false);

  function siteScrolled() {
    if (_scrollPos > _headerOffset) {
      // 下方向にスクロールしているとき
      if (_scrollPos > _offset) {
        if ($root.classList.contains('site-scroll-up')) {
          $root.classList.remove('site-scroll-up');
          $root.classList.add('site-scroll-down');
        } else if (!$root.classList.contains('site-scroll-down')) {
          $root.classList.add('site-scroll-down');
        }
      // 上方向にスクロールしているとき
      } else {
        if ($root.classList.contains('site-scroll-down')) {
          $root.classList.remove('site-scroll-down');
          $root.classList.add('site-scroll-up');
        } else if (!$root.classList.contains('site-scroll-up')) {
          $root.classList.add('site-scroll-up');
        }
      }
      _offset = _scrollPos;
    }
  }
}, false);
